import axios from "axios";
import { get, isEmpty } from "lodash";
import moment from "moment";
import classnames from 'classnames';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Card, NavLink, CardBody, CardHeader, Col, Label, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Table, Nav, NavItem, TabContent, TabPane, CardTitle, CardText } from "reactstrap";
import Swal from "sweetalert2";
import Style from '../../components/PredictionQuestion'
import { apiBaseUrl } from "../../configs/configs";
import { setAmountState, setEditQuestion, setStatus, stateValues } from "../../slices/inPlaySlice";
import { stateRefresh } from "../../slices/inPlaySlice";
const InPlayPrediction = (props) => {
    const { match_id, series_id } = props.match.params;
    const [activeTab, setActiveTab] = useState(props.location.tab || '1');

    // For Tabs Function
    const toggleOne = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }
    const dispatch = useDispatch();
    const opinionTradingSlice = useSelector(state => state.opinionTrading)
    const predictionState = useSelector((state) => state.inPlaySlice);
    const [imageofQustion, setImageofQuestion] = useState(undefined)
    const [tradingList, setTradingList] = useState([])

    const [modal, setModal] = useState(false);

    useEffect(() => {
        getOpinionTrading()
    }, [])

    const onChangeInputText = (e) => {
        const { name, value } = e.target
        dispatch(stateValues({ name, value }))
    }

    const addOptionFiled = () => {
        if (!isEmpty(predictionState.questionStates.question_english)) {
            dispatch(stateValues({ name: 'option', value: [...predictionState.questionStates.option, { option: '', isCorrect: false,  }] }))
        } else {
            alert('fill question field')
        }
    }

    const removeOption = (index) => {
        const options = predictionState.questionStates.option.filter((data, i) => i !== index)
        dispatch(stateValues({ name: 'option', value: options }))
    }

    const setOption = (e, index) => {
        const {name, value} = e.target;
        const selectedOption = predictionState.questionStates.option.find((data, i) => i === index)
        let option = [...predictionState.questionStates.option]
        const data = {
            ...selectedOption,
            id: index + 1,
        }
        data[name] = value
        option[index] = data
        dispatch(stateValues({ name: 'option', value: option }))
    }
    
    // Modal Toggle
    const toggle = () => {
        dispatch(stateRefresh())
        setModal(!modal)
        dispatch(stateValues({ name: 'predic_start_time', value: `${moment().format("YYYY-MM-DD")}T${moment().format("HH:mm")}` }))
        // dispatch(stateValues({ name: 'isAdd', value: true }))
    }

    // Add Question Funtion
    const setQuestion = (e) => {
        dispatch(stateValues({ name: e.target.name, value: e.target.value }))
    }

    // Correct Answer of The question
    const selectCorrectAnswer = (e) => {
        const option = predictionState.questionStates.option.map(data => data.id === Number(e.target.value) ? { ...data, isCorrect: true } : { ...data, isCorrect: false })
        dispatch(stateValues({ name: 'option', value: option }))
    }

    // Image Upload For Question
    const setQuestionImage = (e) => {
        const file = e.target.files[0]
        setImageofQuestion(file)
    }

    // Get Opinion Trading List
    const getOpinionTrading = async () => {
        const url = `${apiBaseUrl}/in_play_prediction/match/${match_id}/series/${series_id}`
        const response = await axios.get(url)
        if (response.data.status === 'success') {
            setTradingList(response.data.data)
        }
    }

    // Question Verification Button here
    const submit = async () => {
        if (isValidate()) {
            await submitQuestion()
        }
    }

    // Add Question Button here
    const submitQuestion = async () => {
        const formData = new FormData()
        let data = {
            ...predictionState.questionStates,
            match_id,
            series_id,
            predic_start_time: moment(predictionState.questionStates.predic_start_time).utc().format(),
            predic_end_time: moment(predictionState.questionStates.predic_end_time).utc().format(),
        }
        formData.append('image', imageofQustion);
        formData.append('data', JSON.stringify(data));
        const result = await axios.post(`${apiBaseUrl}/in_play_prediction/match/${match_id}/series/${series_id}/create`, formData)
        if (result.data.status === 'success') {
            if (!opinionTradingSlice.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Added',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Edit',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        setModal(!modal)
        getOpinionTrading()
    }

    // Alert Function
    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }

    // validation for input box
    const isValidate = () => {
        let status = true
        const data = predictionState.questionStates
        console.log(data,"----data")

        if (isEmpty(data.question_english)) {
            status = false
            getSweetAlert('error', 'Enter the question')
        }else if (!(data.entry_fee > 0)){
            status = false
            getSweetAlert('error', 'Entry Free  Required')
        }else if (data.opening_expected_winning_amount <= 0){
            status = false
            getSweetAlert('error', 'Opening Expected winning Must be greater than 0 ')
        }else if ((data.minimum_winning_amount < 8) || (data.minimum_winning_amount > 19)){
            status = false
            getSweetAlert('error', 'Minimum Winning Must be between 8 to 20')
        }else if ((data.maximum_winning_amount < 9) || (data.maximum_winning_amount > 20)){
            status = false
            getSweetAlert('error', 'Maximum Winning Must be between 8 to 20')
        }else if (data.slots_per_user <= 0) {
            status = false
            getSweetAlert('error', 'Enter Slot Per user')
        }
        else if (isEmpty(data.predic_start_time)) {
            status = false
            getSweetAlert('error', 'Start Time Must Be More Than Present Time')

        }else if (isEmpty(data.predic_end_time) || (moment(data.predic_end_time).format("YYYY-MM-DD, HH:mm") < moment(data.predic_start_time).format("YYYY-MM-DD, HH:mm"))) {
            status = false
            getSweetAlert('error', 'End Time Must be Larger Than Start Time')
        }
        else if (opinionTradingSlice.isSubjective && data.slots_per_user > 2) {
            status = false
            getSweetAlert('error', 'User Slot Not More Than 2')
        } else if (!opinionTradingSlice.isSubjective && data.slots_per_user > 10000) {
            status = false
            getSweetAlert('error', 'User Slot Not More Than 10000')
        }
        else if (opinionTradingSlice.isSubjective && data.slots > 100) {
            status = false
            getSweetAlert('error', 'Slot Not More Than 100')
        }
        else if (!opinionTradingSlice.isSubjective && data.slots > 100000) {
            status = false
            getSweetAlert('error', 'Slot Not More Than 100000')
        }
        else if (Number(data.slots_per_user) >= Number(data.slots)) {
            status = false
            getSweetAlert('error', 'User Slot Not More Than Total Slots')
        }else if (Number(data.admin_commission) < 10) {
            status = false
            getSweetAlert('error', 'Admin Commission Not Less Than 10')
        } else if ((data.option.some(data => isEmpty(data.option)) || data.option.length < 2) ) {
                status = false
                getSweetAlert('error', 'Option must be Filled and minimum two option required')
        } else if (data.option.some(data => !(data.option_open_amount > 0))){
                status = false
                getSweetAlert('error', 'Option Open Amount must be Filled')
        }
        return status
    }

    // question edit slice here
    const editQuestion = (data) => {
        setModal(!modal)
        const tradingData = {
            ...data,
            predic_start_time: `${moment(data.predic_start_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_start_time).format("HH:mm")}`,
            predic_end_time: `${moment(data.predic_end_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_end_time).format("HH:mm")}`,
            isEdit: true,
        };
        dispatch(setEditQuestion(tradingData));
        setModal(!modal)
        getOpinionTrading()
    }

    // Change status of question 
    const changeStatus = async (id, status, data) => {
        const result = await axios.post(`${apiBaseUrl}/change_in_play_prediction/status`, { _id: id, status: 1 - status ,match_id:match_id,series_id:series_id});
        if (result.data.status === "success") {
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Status successfully changed",
                showConfirmButton: false,
                timer: 1500,
            });
            getOpinionTrading()
        }
    };

    // Cancel trading Function here
    const cancelTrading = async (id) => {
        const res = await Swal.fire({
            title: 'Do you want to cancel the Trading ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (res.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: `While Cancelling  is in the process.`,
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.post(`${apiBaseUrl}/cancel_in_play`,{"prediction_id":id,"match_id":match_id, "sport":1}); 
            if (result.data.status === 'Success') {
                // await getQuestions(match_id, series_id, dispatch, addQuestion);
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Trading Cancel successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
                getOpinionTrading()
            }
        } else {
            Swal.close()
        }
    };

    // Set winning function here
    const setWinning = async (data) => {
        const res = await Swal.fire({
            title: 'Do you want to Set Winning ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (res.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: `While We are set the winning!`,
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const trade_id = data._id
            const url = `${apiBaseUrl}/set_winning_inplay`
            // const result = await axios.post(`${apiBaseUrl}/set_winning_inplay`,{"prediction_id":id,"match_id":match_id, "sport":1}); 
            const optionAnser = data.option
            const isCorrectId = (optionAnser.find(data => data.isCorrect)).id
            const bodyData = {
                match_id:match_id,
                prediction_id:trade_id,
                option_id: isCorrectId,
                sport:1,
            }
            const response = await axios.post(url, bodyData)
            if (response.data.status === 'Success') {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Set Winning successfully!",
                    showConfirmButton: false,
                    timer: 1500,
                });
                Swal.close()
                getOpinionTrading()
            }
        } else {
            Swal.close()
        }
    }

    // set Distribute function here
    const setDistribute = async (id) => {
        const res = await Swal.fire({
            title: 'Do you want to Set Distributions ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })

        if (res.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: `While We are set the winning!`,
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const bodyData = {
                match_id:match_id,
                prediction_id:id,
                sport:1,
            }
            const result = await axios.post(`${apiBaseUrl}/win_distribute_inplay`,bodyData);
            if (result.data.status === 'Success') {
                // await getQuestions(match_id, series_id, dispatch, addQuestion);
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Winning Distribute Successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
                getOpinionTrading()
            }
        } else {
            Swal.close()
        }

    };

    // Set Force cancel button function here
    const setForceCancel = async (id) => {
        const res = await Swal.fire({
            title: 'Do you want to Force Cancel ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (res.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: `While We are Force cancelling all!`,
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.post(
                `${apiBaseUrl}/inPlay/forceCancel/${id}`
            );
            if (result.data.status === 'Success') {
                // await getQuestions(match_id, series_id, dispatch, addQuestion);
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Force Cancel Successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
                getOpinionTrading()
            }
        } else {
            Swal.close()
        }
    };

    // check answer function here
    const checkAnser = (data) => {
        const response = data.option.filter((data)=>data.isCorrect)
        if(!isEmpty(response)){
            return true
        }
        else{
            return false
        }
    }

    // for answer valiation 
    const checkAnserForActive = (data) => {
        const response = data.option.filter((data)=>data.isCorrect)
        if(!isEmpty(response)){
            return true
        }
        else{
            return false
        }
    }


    //tab button for live and finished trading

    // const liveTrading = (live) => {
    //     const liveTrade = []
    //     const finishTrade = []
    //     const distributedData = []
    //     for (var trade of tradingList && tradingList) {
    //      if (trade.is_finish) {
    //             finishTrade.push(trade)
    //         } else {
    //             if(trade.status === 1){
    //                 distributedData.push(trade)
    //             }
    //             liveTrade.push(trade)
    //         }
    //     }
    //     if (live === 'live') {
    //         return liveTrade
    //     } else {
    //         return finishTrade
    //     }
    // }


    const liveTrading = (live) => {
        const liveTrade = []
        const finishTrade = []
        const distributedData = []
        for (var trade of tradingList && tradingList) {
            if (trade.is_finish) {
                finishTrade.push(trade)
            } else {
                liveTrade.push(trade)
                // if(trade.status === 1){
                //     distributedData.push(trade)
                // }else{
                //     liveTrade.push(trade)
                // }
            }
        }
        if (live === 'live') {
            return liveTrade
        } else if (live === 'distributed') {
            return distributedData
        } else {
            return finishTrade
        }
    }


    // const distributedData = () => {
    //     const distributedData = []
    //     for (var trade of tradingList && tradingList) {
    //         if (trade.status === 1) {
    //             cosnole
    //             distributedData.push(trade)
    //         } 
    //     }
    //     console.log(distributedData,"ds---")
    //    return distributedData
    // }
    return (
        <>
            <div className="animated fadeIn">
                <Row>
                    <Col xl={12}>
                        <Card>
                            <CardHeader>
                                <i className="fa fa-align-justify"></i>In Play Prediction<small className="text-muted"></small>
                                <div style={{ float: 'right' }}>
                                    <button className="btn btn-success btn-sm" onClick={toggle}>Add Questions</button>
                                </div>
                            </CardHeader>
                            <CardBody className="tabOne">
                                <Nav tabs fill>
                                    <NavItem style={{ width: "24%", fontSize: "15px" }}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => { toggleOne('1'); }}
                                        >
                                            In Play
                                        </NavLink>
                                    </NavItem>

                                    {/* <NavItem style={{ width: "24%", fontSize: "15px" }}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '3' })}
                                            onClick={() => { toggleOne('3'); }}
                                        >
                                            Under Review
                                        </NavLink>
                                    </NavItem> */}

                                    <NavItem style={{ width: "24%", fontSize: "15px" }}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { toggleOne('2'); }}
                                        >
                                            Result
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Question</th>
                                                    <th>Slots Per User</th>
                                                    <th>Opening Expected Winning</th>
                                                    <th>Maximum Amount</th>
                                                    <th>Minimum Amount</th>
                                                    <th>End Time</th>
                                                    <th>Edit</th>
                                                    <th>Status</th>
                                                    <th>Cancel</th>
                                                    <th>Set</th>
                                                    <th>Force Cancel</th>
                                                    {/* <th>Info</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {liveTrading('live').map((data, index) => {
                                                    return <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{data.question_english}</td>
                                                        <td>{data.slots_per_user}</td>
                                                        <td>{data.opening_expected_winning_amount}</td>
                                                        <td>{data.maximum_winning_amount}</td>
                                                        <td>{data.minimum_winning_amount}</td>
                                                        <td>{moment(data.predic_end_time).format('YYYY-MM-DD hh:mm:ss')}</td>
                                                        <td>
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    boxShadow: "0 0 2px #a9f49e",
                                                                    background: "#FFFF00",
                                                                    padding: "5px 10px",
                                                                    color: "#605858",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}
                                                                onClick={() => editQuestion(data)}
                                                            >
                                                                Edit
                                                            </button>
                                                        </td>
                                                        <td>
                                                            {
                                                                    <button
                                                                        style={{
                                                                            outline: "none",
                                                                            border: "none",
                                                                            boxShadow: "0 0 2px #f49e9e",
                                                                            background: data.status ? "green" :  checkAnserForActive(data) ? '#ccc' : 'red' ,
                                                                            padding: "5px 10px",
                                                                            color: "#fff",
                                                                            fontWeight: 700,
                                                                            borderRadius: 5,
                                                                            border: data.status ? "2px solid green" : "2px solid red"
                                                                        }}
                                                                        value={data.status === 1 ? 0 : 1}
                                                                        disabled = {checkAnserForActive(data) ? true :false}
                                                                        onClick={() => changeStatus(data._id, data.status)}
                                                                    >
                                                                        {data.status === 0 ? 'InActive' : 'Active'}
                                                                    </button>
                                                            }
                                                        </td>
                                                        {
                                                            checkAnser(data) && data.status === 0 ?
                                                                <td>
                                                                    {
                                                                        data.is_pred_cancel ? <button
                                                                            style={{
                                                                                outline: "none",
                                                                                border: "1px solid #ccc",
                                                                                padding: "5px 10px",
                                                                                color: "#ccc",
                                                                                fontWeight: 700,
                                                                                borderRadius: 5,
                                                                            }}
                                                                            disabled
                                                                            onClick={() => cancelTrading(data._id)}
                                                                        >
                                                                            Cancel
                                                                        </button> : <button
                                                                            style={{
                                                                                outline: "none",
                                                                                border: "none",
                                                                                background: data.pred_confirm || data.is_prediction_full ? "blue" : "#f63c3a",
                                                                                padding: "5px 10px",
                                                                                color: "#fff",
                                                                                fontWeight: 700,
                                                                                borderRadius: 5,
                                                                            }}
                                                                            disabled={data.pred_confirm || data.is_prediction_full}
                                                                            onClick={() => cancelTrading(data._id)}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    }

                                                                </td> : <td></td>
                                                        }
                                                        <td>
                                                            {
                                                                (data.is_prediction_full || data.pred_confirm || data.is_pred_cancel) && !data.win_distribute && checkAnser(data) &&
                                                                <button
                                                                    style={{
                                                                        outline: "none",
                                                                        border: data.is_winning_set ? '1px solid #ccc':"none",
                                                                        background: data.is_winning_set ? "#fafafa":"green",
                                                                        boxShadow: data.is_winning_set ? 'none' :"0 0 2px #f49e9e",
                                                                        padding: "2px 7px",
                                                                        color: data.is_winning_set? 'rgb(204, 204, 204)':"#fff",
                                                                        fontWeight: 700,
                                                                        borderRadius: 5,
                                                                        marginBottom: '10px'
                                                                    }}
                                                                    // disabled={data.is_winning_set ? true :false}
                                                                    onClick={() => setWinning(data)}
                                                                >
                                                                    SET
                                                                </button>
                                                            }
                                                            <br></br>
                                                            {
                                                                data.is_winning_set &&
                                                                <button
                                                                    style={{
                                                                        outline: "none",
                                                                        border: "none",
                                                                        background: "green",
                                                                        boxShadow: "0 0 2px #f49e9e",
                                                                        padding: "2px 7px",
                                                                        color: "#fff",
                                                                        fontWeight: 700,
                                                                        borderRadius: 5,
                                                                    }}
                                                                    onClick={() => setDistribute(data._id)}
                                                                >
                                                                    Distribute
                                                                </button>
                                                            }
                                                        </td>
                                                        <td>
                                                             {
                                                                data.status === 0 &&    
                                                                <button
                                                                    style={{
                                                                        outline: "none",
                                                                        border: "none",
                                                                        background: "#9f0000",
                                                                        boxShadow: "0 0 2px #f49e9e",
                                                                        padding: "2px 7px",
                                                                        color: "#fff",
                                                                        fontWeight: 700,
                                                                        borderRadius: 5,
                                                                    }}
                                                                    onClick={() => setForceCancel(data._id)}
                                                                >
                                                                    Force Cancel
                                                                </button>
                                                            } 
                                                        </td>
                                                        {/* <td>
                                                            <Link to={{ pathname: `/opinion-trading-details/${data._id}` }}>
                                                                <button style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    background: "#03a9f4",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    padding: "5px 10px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}>Details</button></Link>
                                                        </td> */}

                                                    </tr>
                                                })}
                                            </tbody>
                                        </Table>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Question</th>
                                                    {/* <th>Rate 1</th>
                                                    <th>Rate 2</th> */}
                                                    <th>Answer</th>
                                                    <th>Slots Per User</th>
                                                    <th>End Time</th>
                                                    <th>Edit</th>
                                                    <th>Status</th>
                                                    <th>cancel</th>
                                                    <th>Set</th>
                                                    {/* <th>Force Cancel</th> */}
                                                    {/* <th>Info</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {liveTrading('finish').map((data, index) => {
                                                    return <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{data.question_english}</td>
                                                        {/* <td>{data.rate_id1}</td>
                                                        <td>{data.rate_id2}</td> */}
                                                        {/* <td>{(data.option.find(data => data.isCorrect ? data.isCorrect : '').id) === 'undefined' ? 'hello' : 'NO'}</td> */}
                                                        <td>{get(data.option.find(data => data.isCorrect ? data.isCorrect : ''), 'id', 'Blank Answer')}</td>
                                                        <td>{data.slots_per_user}</td>
                                                        <td>{moment(data.predic_end_time).format('YYYY-MM-DD hh:mm:ss')}</td>
                                                        <td>
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "1px solid #ccc",
                                                                    padding: "5px 10px",
                                                                    color: "#ccc",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}
                                                                disabled
                                                                onClick={() => editQuestion(data)}
                                                            >
                                                                Edit
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "1px solid #ccc",
                                                                    padding: "5px 10px",
                                                                    color: "#ccc",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}
                                                                disabled
                                                                value={data.status === 1 ? 0 : 1}
                                                                onClick={() => changeStatus(data._id, data.status)}
                                                            >
                                                                {data.status === 0 ? 'InActive' : 'Active'}
                                                            </button>
                                                        </td>
                                                        {
                                                            checkAnser(data) && data.status === 0 ?
                                                                <td>
                                                                    {
                                                                        data.is_pred_cancel === 1 ? <button
                                                                            style={{
                                                                                outline: "none",
                                                                                border: "1px solid #ccc",
                                                                                padding: "5px 10px",
                                                                                color: "#ccc",

                                                                                fontWeight: 700,
                                                                                borderRadius: 5,
                                                                            }}
                                                                            disabled
                                                                            onClick={() => cancelTrading(data._id)}
                                                                        >
                                                                            Cancel
                                                                        </button> : <button
                                                                            style={{
                                                                                outline: "none",
                                                                                border: "1px solid #ccc",
                                                                                padding: "5px 10px",
                                                                                color: "#ccc",
                                                                                fontWeight: 700,
                                                                                borderRadius: 5,
                                                                            }}
                                                                            disabled
                                                                            onClick={() => cancelTrading(data._id)}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    }

                                                                </td> : <td></td>
                                                        }
                                                        <td>
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "1px solid #ccc",
                                                                    padding: "5px 10px",
                                                                    color: "#ccc",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}
                                                                disabled
                                                                onClick={() => setWinning(data)}
                                                            >
                                                                SET
                                                            </button>
                                                            <br></br>
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    background: "green",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    padding: "2px 7px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                    marginTop: "10px"
                                                                }}
                                                                onClick={() => setDistribute(data._id)}
                                                            >
                                                                Distribute
                                                            </button>
                                                        </td>
                                                        {/* <td>
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "1px solid #ccc",
                                                                    padding: "5px 10px",
                                                                    color: "#ccc",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}
                                                                disabled
                                                                onClick={() => setForceCancel(data._id)}
                                                            >
                                                                Force Cancel
                                                            </button>
                                                        </td> */}
                                                        {/* <td>
                                                            <Link to={{ pathname: `/opinion-trading-details/${data._id}` }}>
                                                                <button style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    background: "#03a9f4",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    padding: "5px 10px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}>Details</button></Link>
                                                        </td> */}

                                                    </tr>
                                                })}
                                            </tbody>
                                        </Table>
                                    </TabPane>
                                    {/* <TabPane tabId="3">
                                    <Table>
                                            <thead>
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Question</th>
                                                    <th>Rate 1</th>
                                                    <th>Rate 2</th>
                                                    <th>Answer</th>
                                                    <th>Slots Per User</th>
                                                    <th>End Time</th>
                                                    <th>Edit</th>
                                                    <th>Status</th>
                                                    <th>cancel</th>
                                                    <th>Set</th>
                                                    <th>Force Cancel</th>
                                                    <th>Info</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {liveTrading('distributed').map((data, index) => {
                                                    return <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{data.question_english}</td>
                                                        <td>{data.slots_per_user}</td>
                                                        <td>{data.rate_id1}</td>
                                                        <td>{data.rate_id2}</td>
                                                        <td>{moment(data.predic_end_time).format('YYYY-MM-DD hh:mm:ss')}</td>
                                                        <td>
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    boxShadow: "0 0 2px #a9f49e",
                                                                    background: "#FFFF00",
                                                                    padding: "5px 10px",
                                                                    color: "#605858",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}
                                                                onClick={() => editQuestion(data)}
                                                            >
                                                                Edit
                                                            </button>
                                                        </td>
                                                        <td> 
                                                            {
                                                            checkAnserForActive(data) ?
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    background: data.status ? "green" : "rgb(246 60 58 / 68%)",
                                                                    padding: "5px 10px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                    border: data.status ? "2px solid green" : "2px solid red"
                                                                }}
                                                                value={data.status === 1 ? 0 : 1}
                                                                onClick={() => changeStatus(data._id, data.status)}
                                                            >
                                                               {data.status === 0 ? 'InActive' : 'Active'}
                                                            </button> : <button
                                                            disabled
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    boxShadow: "0 0 2px #ccc",
                                                                    background: "#ccc",
                                                                    padding: "5px 10px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                    border: "2px solid #ccc"
                                                                }}
                                                                value={data.status === 1 ? 0 : 1}
                                                                onClick={() => changeStatus(data._id, data.status)}
                                                            >
                                                               {data.status === 0 ? 'InActive' : 'Active'}
                                                            </button>
                                                            }
                                                        </td>
                                                        {
                                                            checkAnser(data) && data.status === 0 ?
                                                                <td>
                                                                    {
                                                                        data.is_pred_cancel === 1 ? <button
                                                                            style={{
                                                                                outline: "none",
                                                                                border: "1px solid #ccc",
                                                                                padding: "5px 10px",
                                                                                color: "#ccc",
                                                                                fontWeight: 700,
                                                                                borderRadius: 5,
                                                                            }}
                                                                            disabled
                                                                            onClick={() => cancelTrading(data._id)}
                                                                        >
                                                                            Cancel
                                                                        </button> : <button
                                                                            style={{
                                                                                outline: "none",
                                                                                border: "none",
                                                                                background: "#f63c3a",
                                                                                padding: "5px 10px",
                                                                                color: "#fff",
                                                                                fontWeight: 700,
                                                                                borderRadius: 5,
                                                                            }}
                                                                            onClick={() => cancelTrading(data._id)}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    }

                                                                </td> : <td></td>
                                                        }
                                                        <td>
                                                            {
                                                                data.is_slot_cancel === 1 &&
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    background: "green",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    padding: "2px 7px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                    marginBottom: '10px'
                                                                }}
                                                                onClick={() => setWinning(data)}
                                                            >
                                                                SET
                                                            </button>
                                                            }
                                                            <br></br>
                                                            {
                                                                data.is_pred_winset === 1 && 
                                                                <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    background: "green",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    padding: "2px 7px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}
                                                                onClick={() => setDistribute(data._id)}
                                                            >
                                                                Distribute
                                                            </button>
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                 data.status === 0 && 
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    background: "#9f0000",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    padding: "2px 7px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}
                                                                onClick={() => setForceCancel(data._id)}
                                                            >
                                                                Force Cancel
                                                            </button>
                                                            }
                                                        </td>
                                                        <td>
                                                            <Link to={{ pathname: `/opinion-trading-details/${data._id}` }}>
                                                                <button style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    background: "#03a9f4",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    padding: "5px 10px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}>Details</button></Link>
                                                        </td>

                                                    </tr>
                                                })}
                                            </tbody>
                                        </Table>
                                    </TabPane> */}
                                </TabContent>
                                <Row>
                                <Modal isOpen={modal} toggle={toggle} backdrop="static">
                                        <ModalHeader toggle={toggle}>Add Question</ModalHeader>
                                        <ModalBody>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                                <div style={{ width: '30%' }}>
                                                    <p style={{ margin: 0 }}>Entry Fee</p>
                                                    <Input placeholder='Entry Fee' type='number' name='entry_fee' onChange={(e) =>  setQuestion(e)} value={predictionState.questionStates.entry_fee} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                                                </div>
                                                <div style={{ width: '30%' }}>
                                                    <p style={{ margin: 0 }}>Total Slots</p>
                                                    <Input placeholder='Slots' type='number' name='slots' onChange={(e) =>  setQuestion(e)} value={predictionState.questionStates.slots} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                                                </div>
                                                <div style={{ width: '30%' }}>
                                                    <p style={{ margin: 0 }}>Slots Per User</p>
                                                    <Input placeholder='slots per user' type='number' name='slots_per_user' onChange={(e) =>  setQuestion(e)} value={predictionState.questionStates.slots_per_user} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                                                </div>
                                                <div style={{ width: '40%' }}>
                                                    <p style={{ margin: 0 }}>Admin Commission</p>
                                                    <Input placeholder='Admin Commission' type='number' name='admin_commission' onChange={setQuestion} value={predictionState.questionStates.admin_commission} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                                                </div>
                                                <div style={{ width: '55%' }}>
                                                    <p style={{ margin: 0 }}>Opening Expected Winning</p>
                                                    <Input placeholder='Opening Expected Winning' type='number' name='opening_expected_winning_amount' onChange={setQuestion} value={predictionState.questionStates.opening_expected_winning_amount} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                                                </div>
                                            </div>
                                            <div className={Style.date_time_picker_container}>
                                                <div>
                                                    <p>Start Date and Time</p>
                                                    <Input type='datetime-local' name={'predic_start_time'} value={predictionState.questionStates.predic_start_time} onChange={setQuestion} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />
                                                </div>
                                                <div>
                                                    <p>End Date and Time</p>
                                                    <Input type='datetime-local' name={'predic_end_time'} value={predictionState.questionStates.predic_end_time} onChange={setQuestion}  />
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 10px' }}>
                                                <div>
                                                    <Label for={'minimum_winning_amount'} style={{ padding: 0 }}>Minimum Winning Amount</Label>
                                                    <Input id='minimum_winning_amount' onChange={(e) =>setQuestion(e)} value={predictionState.questionStates.minimum_winning_amount} type='text' name='minimum_winning_amount' placeholder="Enter Minimum value"  disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                                                </div>
                                                <div>
                                                    <Label for={'maximum_winning_amount'} style={{ padding: 0 }}>Maximum Winning Amount</Label>
                                                    <Input id='maximum_winning_amount' onChange={(e) => setQuestion(e)} value={predictionState.questionStates.maximum_winning_amount} type='text' name="maximum_winning_amount" placeholder='Enter Maximum Value' disabled={get(predictionState, "questionStates.status") === undefined ? false : true} ></Input>
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 10px' }}>
                                                <div>
                                                    <Input id='pred_confirm' checked={JSON.parse(predictionState.questionStates.pred_confirm)} value={!JSON.parse(predictionState.questionStates.pred_confirm)} type='checkbox' placeholder='Entry Fee' name='pred_confirm' onChange={setQuestion} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} ></Input>
                                                    <Label for={'pred_confirm'} style={{ padding: 0 }}>Prediction Confirm</Label>
                                                </div>
                                                {/* <div>
                                                    <Input id='pred_autocreate' checked={JSON.parse(predictionState.questionStates.pred_autocreate)} type='checkbox' name='pred_autocreate' onChange={setQuestion} value={!JSON.parse(predictionState.questionStates.pred_autocreate)} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                                                    <Label for={'pred_autocreate'} style={{ padding: 0 }}>Prediction Autocreate</Label>
                                                </div> */}
                                            </div>
                                            <Input id='question' name='question_english' value={predictionState.questionStates.question_english} onChange={setQuestion} placeholder='write question in english ?' style={{ margin: '10px 5px' }} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>
                                            <Input value={predictionState.questionStates.question_hindi} name='question_hindi' onChange={setQuestion} placeholder='सवाल हिंदी में लिखें ?' style={{ margin: '10px 5px' }} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}></Input>

                                            {predictionState.questionStates.option.map((data, index) => <div key={index} style={{ display: 'flex', alignItems: 'center' }}><Input placeholder={`option ${index + 1}`} value={data.option} name={'option'} style={{ margin: '10px 5px' }} onChange={(e) => setOption(e, index)} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}>

                                            </Input><Input value={data.option_open_amount} name={'option_open_amount'} onChange={(e) => setOption(e,index)} style={{width:"90px",marginRight:"3px"}} placeholder="open amount" disabled={get(predictionState, "questionStates.status") === undefined ? false : true}/> 

                                            
                                            <Button style={{ background: '#e62828e6', color: '#fff', border: 'none' }} onClick={() => removeOption(index)} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}>Delete</Button></div>)}
                                            {predictionState.questionStates.option.length < 10 && <Button style={{ display: 'block', margin: '10px auto' }} onClick={addOptionFiled} disabled={get(predictionState, "questionStates.status") === undefined ? false : true}>Add Options</Button>}



                                                <Input style={{ margin: '10px' }} type='select' value={get(predictionState.questionStates.option.find(data => data.isCorrect), 'id', '')} disabled={(get(predictionState, "questionStates.status") ? true : false) || (get(predictionState, "questionStates.isEdit") ? false :true)} onChange={selectCorrectAnswer}>
                                                    <option>Select Answer</option>
                                                    {predictionState.questionStates.option.map((data, index) =>
                                                        <option value={data.id} key={index}>{data.option}</option>
                                                    )}
                                                </Input>
                                            <div>
                                                <Input type="file" accept='image/*' name={'image'} onChange={setQuestionImage} />
                                            </div>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button color="primary" onClick={submit}>Submit</Button>
                                            <Button color="secondary" onClick={toggle}>Cancel</Button>
                                        </ModalFooter>
                                    </Modal>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default InPlayPrediction